import React from "react";
import ActionButton from "./ActionButton";
import { FaUpload } from "react-icons/fa";
import { useHandleFileUpload } from "../../hooks/useHandleFileUpload";
import { useBPMNRenderer } from "../../hooks/useBPMNRenderer";
import { useDispatch } from "react-redux";
import { addMessage, addHistoryEntry, resetApp } from "../../store/actions";
import { storageKeys } from "../../constants/storageKeys";
const ImportButton = () => {
  const dispatch = useDispatch();
  const renderBPMN = useBPMNRenderer();

  const handleFileUpload = useHandleFileUpload();

  const fileInputRef = React.useRef(null); // Trigger file input change event when the button is clicked
  const handleClick = () => {
    fileInputRef.current.click(); // Trigger click on the hidden file input element
  };

  // Handles the file input change event when a user selects a file to import
  const handleChange = (e) => {
    const file = e.target.files[0]; // Get the first selected file
    if (file) {
      // Use the custom hook to handle file upload and parsing
      handleFileUpload(file)
        .then(async (importedData) => {
          try {
            // Reset the app state before importing new data
            dispatch(resetApp());

            // Restore chat messages if present in the imported data
            if (importedData.messages) {
              importedData.messages
                .slice() // Create a shallow copy
                .reverse() // Reverse to maintain correct order when dispatching
                .forEach((msg) => {
                  dispatch(addMessage(msg));
                });
            }

            // Restore history entries if present
            if (importedData.history?.entries) {
              importedData.history.entries.forEach((entry) => {
                dispatch(addHistoryEntry(entry));
              });

              // Render the BPMN diagram from the current pointer's jsonData
              await renderBPMN(
                JSON.parse(
                  importedData.history?.entries[importedData.history?.pointer]
                    ?.jsonData
                )
              );
            }

            // Restore localStorage data, skipping certain keys
            if (importedData.localStorage) {
              Object.entries(importedData.localStorage).forEach(
                ([key, value]) => {
                  // Skip restoring session-specific or registry keys
                  if (
                    key === storageKeys.SESSION_ID ||
                    key === storageKeys.CHECKERS ||
                    key === storageKeys.CHECKERS_REGISTRY_BASEURL
                  ) {
                    return; // Skip these keys
                  }
                  localStorage.setItem(key, value); // Restore other keys
                }
              );
            }

            // Restore sessionStorage data
            if (importedData.sessionStorage) {
              Object.entries(importedData.sessionStorage).forEach(
                ([key, value]) => {
                  sessionStorage.setItem(key, value);
                }
              );
            }

            
          } catch (error) {
            // If an error occurs during rendering, notify the user
            dispatch(
              addMessage({
                sender: "assistant",
                content: `There was an error in rendering your model.`,
              })
            );
          }
        })
        .catch(() => {
          // If an error occurs during import, notify the user
          dispatch(
            addMessage({
              sender: "assistant",
              content: `There was an error in importing your chat state. Check the console for more details.`,
            })
          );
        });
    }

    e.target.value = ""; // Clear the file input value to allow re-uploading the same file
  };

  return (
    <>
      <ActionButton
        icon={FaUpload}
        tooltip="Import"
        onClick={handleClick}
        variant="dropdown"
      />

      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }} // Hide the file input
        onChange={handleChange} // Handle file change when a file is selected
      />
    </>
  );
};

export default ImportButton;
